import React from "react";

const Description = () => {
  return (
    <div id="description" className="basic-2">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h2>What Will You Learn In Our SEO Focused Training Course</h2>
          </div>{" "}
          {/* end of col */}
        </div>{" "}
        {/* end of row */}
        <div className="row">
          <div className="col-lg-6">
            <ul className="list-unstyled li-space-lg first">
              <li className="media">
                <i className="bullet">1</i>
                <div className="media-body">
                  <h4>Optimizing your site for mobile devices</h4>
                  <p>
                    One of the keys of great SEO is having a mobile friendly
                    website which works smoothly on all devices
                  </p>
                </div>
              </li>
              <li className="media">
                <i className="bullet">2</i>
                <div className="media-body">
                  <h4>Understand how users search</h4>
                  <p>
                    It's not enough anymore to find relevant industry keywords
                    and write huge amounts of content{" "}
                  </p>
                </div>
              </li>
              <li className="media">
                <i className="bullet">3</i>
                <div className="media-body">
                  <h4>Write for humans optimize for engines</h4>
                  <p>
                    Write well structured and understandable articles not just a
                    mix of paragraphs that contain keywords
                  </p>
                </div>
              </li>
            </ul>
          </div>{" "}
          {/* end of col */}
          <div className="col-lg-6">
            <ul className="list-unstyled li-space-lg second">
              <li className="media">
                <i className="bullet">4</i>
                <div className="media-body">
                  <h4>Analyse your existing search traffic</h4>
                  <p>
                    A good action plan comes out of understanding where your
                    current position is and the environment
                  </p>
                </div>
              </li>
              <li className="media">
                <i className="bullet">5</i>
                <div className="media-body">
                  <h4>Keep updated with the latest changes</h4>
                  <p>
                    Google changes it's search indexing algorithm twice a year
                    so it's important to stay updated with news
                  </p>
                </div>
              </li>
              <li className="media">
                <i className="bullet">6</i>
                <div className="media-body">
                  <h4>Learn the most important ranking factors</h4>
                  <p>
                    Learn which are the most important search engine ranking
                    factors and optimize your website accordnigly
                  </p>
                </div>
              </li>
            </ul>
          </div>{" "}
          {/* end of col */}
        </div>{" "}
        {/* end of row */}
      </div>{" "}
      {/* end of container */}
    </div>
  );
};

export default Description;
